<template>
  <nav id="the-header" class="relative flex flex-wrap items-center justify-between px-2 bg-gray h-60-px w-full shadow">
    <!-- 左寄せパーツ -->
    <div class="container flex flex-nowrap w-3/6">
      <div class="div-logo relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
        <a href="#" @click.prevent="goToTop">
          <img class="logo" :src="logoImgPath" :alt="$t('common.title_pages.default')" />
        </a>
      </div>
    </div>

    <!-- 右寄せパーツ -->
    <div class="container w-3/6">
      <div class="flex flex-row-reverse flex-nowrap items-center">
        <!-- 部署名と氏名 -->
        <div class="identification">
          <div class="cursor-pointer text-xs px-3 pl-4 py-3 w-full flex">
            <img class="w-6 h-6 object-contain rounded-full" :src="imageSrc" alt="member-image" />
            <div class="inline-flex ml-2 pl-1 leading-relaxed items-center">
              <div v-if="memberName" class="ml-3 align-middle">{{ memberName }}</div>
            </div>
          </div>
          <!-- サブメニュー -->
          <div class="sub-menu w-60 absolute bg-white text-sm z-50 rounded shadow-lg hidden px-2 py-2">
            <div @click="openMemberEditModal">
              <p class="cursor-pointer hover-fcs-green pl-3 py-1">
                {{ $t('common.header.edit') }}
              </p>
            </div>
            <a href="#" @click.prevent="submitLogout">
              <p class="cursor-pointer hover-fcs-green pl-3 py-1">
                {{ $t('common.header.logout') }}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- メンバー編集 -->
    <edit-member-modal
      ref="openMemberEditModal"
      :title="$t('common.header.edit_modal.title')"
      :errors="errors"
      @update="clickUpdateButton"
    ></edit-member-modal>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { headerLogoMixin } from '@/member/mixins/styleMixin'
import { impersonatingMixin } from '@/member/mixins/impersonatingMixin'
import EditMemberModal from '@/member/components/common/modal/EditMemberModal'

export default {
  name: 'TheHeader',
  components: {
    EditMemberModal,
  },
  mixins: [impersonatingMixin, headerLogoMixin],
  data() {
    return {
      errors: [],
    }
  },
  computed: {
    ...mapGetters(['profile', 'isGeneralDivision']),
    memberInfo() {
      return this.profile?.member_info
    },
    cMember() {
      return this.memberInfo?.c_member
    },
    cDivision() {
      return this.cMember?.c_division
    },
    imageSrc() {
      return this.memberInfo?.image?.image_full_url || '/images/member/default-member-image.png'
    },
    impersonatedDivisionName() {
      return this.profile?.impersonated_division_name
    },
    partnerName() {
      return this.cMember?.c_partner?.name || ''
    },
    isShowCDivision() {
      return false
    },
    memberName() {
      return this.memberInfo?.name || ''
    },
  },
  async created() {
    await this.getProfile()
  },
  methods: {
    ...mapActions({
      getProfile: 'memberStore/getProfile',
      logout: 'authStore/logout',
      changeToken: 'authStore/changeToken',
      deleteImpersonate: 'authStore/deleteImpersonate',
      updateMember: 'memberStore/update',
    }),
    async submitLogout() {
      // delete impersonating info if member belong to general division
      if (this.isGeneralDivision) {
        await this.deleteHandler()
      }
      // logout user
      const result = await this.logout({
        url: route('member.auth.logout'),
      })

      if (result && result.success) {
        return this.$router.push({ name: 'auth.login' })
      }
    },
    goToTop() {
      if (this.profile?.member_info?.role_id === this.$constantGenerate.Member.ROLE_USER) {
        return this.$router.push({ name: 'fcs.members.list' })
      }
      if (this.profile?.member_info?.role_id === this.$constantGenerate.Member.ROLE_OPERATOR) {
        return this.$router.push({ name: 'fcs.organizations' })
      }
      return this.$router.push({ name: 'fcs.members.list' })
    },
    openMemberEditModal() {
      this.$refs.openMemberEditModal.onOpenModal({
        memberInfo: this.memberInfo,
      })
    },
    async clickUpdateButton({ name, email, currentPassword, newPassword, confirmNewPassword }) {
      const param = {
        name: name,
        email: email,
        current_password: currentPassword,
        new_password: newPassword,
        confirm_new_password: confirmNewPassword,
      }
      const result = await this.updateMember(param)
      if (!result?.success) {
        this.errors = Object.values(result?.data?.errors).flat()
        return
      }
      if (result) {
        // ページをリロードする
        window.location.reload()
        return
      }
    },
  },
}
</script>

<style scoped lang="scss">
.logo {
  width: 136px;
}

.sub-menu {
  margin-left: -50px;
}

.identification:hover > .sub-menu,
.sub-menu:hover {
  display: block;
}

.hover-fcs-green:hover {
  color: #3b7e34;
  background-color: #f0ffe0;
}
</style>
